import React, { useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import axios from "axios";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
export default function DeleteProfileImg({ id, cancelModal,fetchData }) {
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthContext();
//styled
  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      const response = await axios.delete(
        `${ApiConnectionString}/api/ProfileImage/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      
      if (response.status == 200) {
        setComplete(true);
      }
    } catch (error) {
      console.error("Error deleting profile image:", error);
      // Handle error (e.g., show an error message to the user)
    } finally {
      setIsLoading(false); // Stop loading regardless of success or failure
    }
  };
  
  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else {
    if (complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
          <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Image Deleted</p></div> 

          <p>The image was successfully deleted.</p>

            <div className="send-modal-footer">
              <button  className="pointer cancelButton fw-bold mx-2 px-3" onClick={() => {cancelModal();fetchData()}}>
                Okay
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
          <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Delete Image</p></div> 

<button
             type="button"
             className="close-button"
             onClick={cancelModal}
             aria-label="Close"
           >
             &times;
           </button>

           <p>Please confirm that you wish to delete this image.</p>

            <div className="send-modal-footer">
              <button className="saveChanges-button mx-3" onClick={handleConfirm}>
                Confirm
              </button>
              <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
